import { useEffect, useState } from "react"
import { TranslationsStringsType } from "../../models/enum/rsvpEnum"
import { RsvpDetails, Settings, StepsTranslations } from "../../models/api/rsvpApiTypes"
import { useAppSelector } from "../../hook/useReduxHooks"
import { RootState } from "../../redux/store"
import { resolveTranslation } from "../../utils/translations"
import RsvpBox from "../RsvpBox"
import StepEmail from "./StepEmail"
import mailStepIcon from "../../icon/email-icon.svg"

interface StepEmailBoxProps {
  settings: Settings
  rsvp: RsvpDetails
  setRsvp: (rsvp: RsvpDetails) => void
  stepPipeline: string[]
  setStep: (name: string) => void
}

export default function StepEmailBox({ settings, rsvp, stepPipeline, setRsvp, setStep }: StepEmailBoxProps) {
  const [emailStrings, setEmailStringsStrings] = useState<StepsTranslations | undefined>({
    lang: "",
    strings: [],
  })
  const language = useAppSelector((state: RootState) => state.languageReducer.language).toLocaleLowerCase()

  useEffect(() => {
    const newEmailStrings =
      resolveTranslation(settings.steps?.find((x) => x.name === "email")?.translations ?? [], language)
    setEmailStringsStrings(newEmailStrings)
  }, [language, settings.steps])

  return (
    <div className="box">
      <RsvpBox
        iconAlt="mailStepIcon"
        iconSource={mailStepIcon}
        title={emailStrings?.strings.find((x) => x.type === TranslationsStringsType.TITLE)?.value}
        description={emailStrings?.strings.find((x) => x.type === TranslationsStringsType.DESCRIPTION)?.value}
      >
        <StepEmail
          buttonColor={settings.rsvpStyle.buttonColor === null ? "#0c6efb" : settings.rsvpStyle.buttonColor}
          backButtonColor={settings.rsvpStyle.backButtonColor === null ? "#a6b7d4" : settings.rsvpStyle.backButtonColor}
          strings={emailStrings?.strings}
          rsvp={rsvp}
          setRsvp={(rsvp) => setRsvp(rsvp)}
          stepPipeline={stepPipeline}
          setStep={(name) => setStep(name)}
          languge={language}
        />
      </RsvpBox>
    </div>
  )
}
